module.exports = __webpack_public_path__ + "img/ocean_current.9a110d44.svg";